import React, { memo, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import LanguageContext from "../helper/LanguageContext";
import useTrialCountdown from "../hooks/useTrialCountdown";
import { settleEndedTrial } from "../services/PaymentService";
import { formatTrialCountdown } from "../utils/trialCountdown";

/**
 * Remaining Kjuup.io trial time: "{days} days left" until the last day, then a
 * live "5 hours / 12 minutes / 8 seconds remaining". Its own component so the
 * one-second tick re-renders this line only, not the page around it.
 *
 * `lastDayOnly` renders nothing until the final 24 hours.
 */
function TrialCountdownText({ as: Tag = "div", className, style, lastDayOnly = false }) {
  const { strings } = useContext(LanguageContext);
  const dispatch = useDispatch();
  const trialing = useSelector((s) => !!s.subscription?.trialing);
  const trialEnd = useSelector((s) => s.subscription?.trialEnd || null);
  const clockOffsetMs = useSelector((s) => s.subscription?.clockOffsetMs || 0);

  const { msLeft, lastDay, ended } = useTrialCountdown({
    trialEnd,
    clockOffsetMs,
    enabled: trialing,
    onEnded: () => settleEndedTrial(dispatch),
  });

  if (msLeft == null) return null;
  if (lastDayOnly && !lastDay && !ended) return null;
  return (
    <Tag className={className} style={style} data-testid="trial-countdown">
      {formatTrialCountdown(msLeft, strings)}
    </Tag>
  );
}

export default memo(TrialCountdownText);
